export default __webpack_public_path__ + "alberta-weight.478b51ab0c8e547ea29d.svg";